import {
    BLOCKEDWORD_CREATE,
    BLOCKEDWORD_LIST,
    BLOCKEDWORD_UPDATE
} from "../actions";

export function blockedWord(currentState = {}, action) {
    switch (action.type) {
        case BLOCKEDWORD_CREATE:
            return {
                type: action.type,
                list: currentState.list ? currentState.list.concat(action.list) : [action.list]
            }
        case BLOCKEDWORD_LIST:
            return currentState = action
        case BLOCKEDWORD_UPDATE:
            return {
                type: action.type,
                list:  currentState.list.map(current => current.id  === action.list.id ? action.list : current)
            }
        default:
            return currentState
    }
}